import { Modal, Pressable, Text } from "react-native";
import React from "react";
import { View } from "ui/atoms/view";
import { CloseIcon, Icon } from "ui/gluestack/icon";
import { SyncSummary } from "../molecules/SyncSummary";
import { SyncProgressTable } from "../organism/SyncProgressTable";
import { OfflineRequestStatusModel } from "../../../services/api/types/offline/models/OfflineRequestStatusModel";

export interface Props {
  isVisible: boolean;
  onClose: () => void;
  title?: string;
  noBackgroundClose?: boolean;
  data?: OfflineRequestStatusModel[];
  isLoading?: boolean;
}

export function SyncProgressModal({
  isVisible,
  onClose,
  title,
  noBackgroundClose,
  data,
  isLoading,
}: Props) {
  return (
    <Modal
      visible={isVisible}
      onRequestClose={onClose}
      transparent
      animationType="fade"
    >
      <View className="p-5 flex-1 bg-black/50 items-center justify-center relative">
        {!noBackgroundClose ? (
          <Pressable
            onPress={onClose}
            className="absolute top-0 left-0 bottom-0 right-0"
          />
        ) : null}
        <View
          className={`p-10 rounded-xl bg-white drop-shadow-xl max-w-[980px] lg:w-[980px] mx-auto max-h-[604px] lg:h-[980px] overflow-y-scroll`}
        >
          <View className="pb-6 flex flex-row justify-between items-center border-b border-border-200">
            <Text className="text-gray-700 font-semibold text-lg">{title}</Text>
            <Pressable onPress={onClose}>
              <Icon as={CloseIcon} size="md" />
            </Pressable>
          </View>
          <View className="pt-8">
            <SyncSummary data={data}></SyncSummary>
          </View>
          <View className="pt-14 w-full min-w-[680px] max-w-[980px]">
            <SyncProgressTable data={data} isLoading={isLoading} />
          </View>
        </View>
      </View>
    </Modal>
  );
}
